import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';

const TopSetion = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const handleTabClick = (tabName) => {
        // Handle tab navigation
        navigate(`/${tabName}`);
    };


    return (
        <>

            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-image hero-background">
                    <div className="hero-overlay">
                        <div className="hero-content">
                            <div className="hero-yellow-line"></div>
                            <h1 className="hero-title">고객센터</h1>
                        </div>
                    </div>
                </div>
            </section>


            {/* Sub Navigation */}
            <section className="sub-navigation">
                <div className="tab-container">
                    <a
                        className={`tab-link ${location.pathname.includes('announcements') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('announcements');
                        }}
                    >
                        공지사항
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('memorial-news') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('memorial-news');
                        }}
                    >
                        추모원 소식
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('faq') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('faq');
                        }}
                    >
                        자주하는 질문
                    </a>
                    <a
                        className={`tab-link ${location.pathname.includes('contact-us')
                            || location.pathname.includes('inquiry-details') || location.pathname.includes('contact-secret-post') ? 'active' : ''}`}
                        onClick={(e) => {
                            handleTabClick('contact-us');
                        }}
                    >
                        문의하기
                    </a>
                </div>
            </section>

        </>
    )
}

export default TopSetion;